import React from 'react';

const SvgIr = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="IR_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="IR_svg__b" fill="#fff">
        <use xlinkHref="#IR_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#38BB56" mask="url(#IR_svg__b)" d="M0 0h28v6.667H0z" />
      <path fill="#DE1B27" mask="url(#IR_svg__b)" d="M0 13.333h28V20H0z" />
      <path
        d="M1.333 5.67c0-.186.143-.337.337-.337h.66c.186 0 .337.143.337.337v.66a.331.331 0 0 1-.337.337h-.66a.331.331 0 0 1-.337-.337v-.66zM4 5.67c0-.186.143-.337.336-.337h.66c.187 0 .337.143.337.337v.66a.331.331 0 0 1-.336.337h-.66A.331.331 0 0 1 4 6.33v-.66zm2.667 0c0-.186.142-.337.336-.337h.66c.186 0 .337.143.337.337v.66a.331.331 0 0 1-.336.337h-.66a.331.331 0 0 1-.337-.337v-.66zm2.666 0c0-.186.143-.337.337-.337h.66c.186 0 .337.143.337.337v.66a.331.331 0 0 1-.337.337h-.66a.331.331 0 0 1-.337-.337v-.66zm2.667 0c0-.186.143-.337.336-.337h.66c.187 0 .337.143.337.337v.66a.331.331 0 0 1-.336.337h-.66A.331.331 0 0 1 12 6.33v-.66zm2.667 0c0-.186.142-.337.336-.337h.66c.186 0 .337.143.337.337v.66a.331.331 0 0 1-.336.337h-.66a.331.331 0 0 1-.337-.337v-.66zm2.666 0c0-.186.143-.337.337-.337h.66c.186 0 .337.143.337.337v.66a.331.331 0 0 1-.337.337h-.66a.331.331 0 0 1-.337-.337v-.66zm2.667 0c0-.186.143-.337.336-.337h.66c.187 0 .337.143.337.337v.66a.331.331 0 0 1-.336.337h-.66A.331.331 0 0 1 20 6.33v-.66zm2.667 0c0-.186.142-.337.336-.337h.66c.186 0 .337.143.337.337v.66a.331.331 0 0 1-.336.337h-.66a.331.331 0 0 1-.337-.337v-.66zm2.666 0c0-.186.143-.337.337-.337h.66c.186 0 .337.143.337.337v.66a.331.331 0 0 1-.337.337h-.66a.331.331 0 0 1-.337-.337v-.66zm-24 8c0-.186.143-.337.337-.337h.66c.186 0 .337.143.337.337v.66a.331.331 0 0 1-.337.337h-.66a.331.331 0 0 1-.337-.337v-.66zm2.667 0c0-.186.143-.337.336-.337h.66c.187 0 .337.143.337.337v.66a.331.331 0 0 1-.336.337h-.66A.331.331 0 0 1 4 14.33v-.66zm2.667 0c0-.186.142-.337.336-.337h.66c.186 0 .337.143.337.337v.66a.331.331 0 0 1-.336.337h-.66a.331.331 0 0 1-.337-.337v-.66zm2.666 0c0-.186.143-.337.337-.337h.66c.186 0 .337.143.337.337v.66a.331.331 0 0 1-.337.337h-.66a.331.331 0 0 1-.337-.337v-.66zm2.667 0c0-.186.143-.337.336-.337h.66c.187 0 .337.143.337.337v.66a.331.331 0 0 1-.336.337h-.66A.331.331 0 0 1 12 14.33v-.66zm2.667 0c0-.186.142-.337.336-.337h.66c.186 0 .337.143.337.337v.66a.331.331 0 0 1-.336.337h-.66a.331.331 0 0 1-.337-.337v-.66zm2.666 0c0-.186.143-.337.337-.337h.66c.186 0 .337.143.337.337v.66a.331.331 0 0 1-.337.337h-.66a.331.331 0 0 1-.337-.337v-.66zm2.667 0c0-.186.143-.337.336-.337h.66c.187 0 .337.143.337.337v.66a.331.331 0 0 1-.336.337h-.66A.331.331 0 0 1 20 14.33v-.66zm2.667 0c0-.186.142-.337.336-.337h.66c.186 0 .337.143.337.337v.66a.331.331 0 0 1-.336.337h-.66a.331.331 0 0 1-.337-.337v-.66zm2.666 0c0-.186.143-.337.337-.337h.66c.186 0 .337.143.337.337v.66a.331.331 0 0 1-.337.337h-.66a.331.331 0 0 1-.337-.337v-.66z"
        fillOpacity={0.5}
        fill="#FFF"
        mask="url(#IR_svg__b)"
      />
      <path
        d="M12.788 8.856a1.667 1.667 0 1 0 2.44.019l-2.44-.02z"
        stroke="#D80915"
        strokeWidth={0.667}
        mask="url(#IR_svg__b)"
      />
      <rect
        fill="#D80915"
        mask="url(#IR_svg__b)"
        x={13.333}
        y={9.333}
        width={1.333}
        height={2.667}
        rx={0.667}
      />
    </g>
  </svg>
);

export default SvgIr;
